module.exports = __webpack_public_path__ + "img/icon-view.6adf4b76.svg";